import { CLPL } from '../constants/measure';
import INSTRUCTIONS from './clplConstants';
import { fetchCLPLContent, saveCLPLResponse } from './clplActions';

const CLPLFlowStrategy = {
    measure: CLPL.MEASURE,
    assessment: CLPL.ASSESSMENT,
    instructions: INSTRUCTIONS,
    fetchContent: fetchCLPLContent,
    saveResponse: saveCLPLResponse,
};

export default CLPLFlowStrategy;
